export enum behandelingLabels {
    leefstijl_verandering = 'Leefstijl verandering',
    mra = 'MRA',
    pap = 'PAP',
    spt = 'SPT',
}
